import React from 'react'
import './Error.css'

const Error = ({ message, retry }) => (
    <div className="error">
        <div className="details">
            <i className="fa fa-exclamation-triangle" />
            <div>
                <span className="oops">Oops, something went wrong.</span>
                <br />
                {message}
                <br />
            </div>
        </div>
        <div className="btn btn-white" onClick={retry}>
            <i className="fa fa-refresh" /> Retry
        </div>
    </div>
)

export default Error
